<template>
    <div class="mt-10 mb-5 text-center">
        <h1 class="m-3 mob-h1-font">Welcome to {{site_name}}</h1>
        <h5 class="mb-cus-10 mob-h5-font">Select your location to start your seasonal lease.</h5>
        <template v-if="is_advance_seasonal">
            <template v-for="(item, index) in multi_location_list_for_seasonal">
                <a class="btn btn-danger m-cus-10" style="color: #fff; min-width: 100px" @click="redirectByLink(item.link,item.name)">{{item.name}}</a>
            </template>
        </template>
        <template v-else>
            <template v-for="(item, index) in multi_location_list">
                <a class="btn btn-danger m-cus-10" style="color: #fff; min-width: 100px" @click="redirectByLink(item.link,item.name)">{{item.name}}</a>
            </template>
        </template>
    </div>
</template>

<script>
import StepperComponentMixin from "../../../mixins/StepperComponentMixin";

export default {
    name: "MultiLocation",
    mixins : [StepperComponentMixin],
    data      : () => ({
        is_advance_seasonal: false,
    }),
    computed: {
        site_name() {
            return this.$store.state.resources.config.site_name;
        },
        frontend_view_folder() {
            return this.$store.state.resources.config.frontend_view_folder;
        },
        multi_location_list() {
            return this.$store.state.resources.config.multi_location_list;
        },
        multi_location_list_for_seasonal() {
            return this.$store.state.resources.config.multi_location_list_for_seasonal;
        }
    },
    methods: {
        redirectByLink(link,name){
            console.log(link, window.location.href)
            if(window.location.href!==link){
                window.location.href = link;
            }else{
                this.$store.commit('set_model_value',{path:'model.reservation.location',value: location})
                this.stepNext();
            }
        }
    },
    mounted() {
        if(window.location.href.includes('seasonal')){
            this.is_advance_seasonal = true;
        }
        const query = new URLSearchParams(window.location.search);
        if(query.has('location_name') && query.get('location_name') != null){
            const locationName = query.get('location_name');
            if(this.is_advance_seasonal == true){
                console.log('Seasonal Multi Location');
                const locationExists = Object.values(this.multi_location_list_for_seasonal).some(
                    (item) => item.name === locationName
                );    
                if (locationExists) {
                    this.$store.commit('set_model_value',{path:'model.reservation.location',value: query.get('location_name')})
                    this.stepNext();
                } else {
                    console.log('Invalid location_name:', locationName);
                }
            }else{
                const locationExists = Object.values(this.multi_location_list).some(
                    (item) => item.name === locationName
                );   
                if (locationExists) {
                    this.$store.commit('set_model_value',{path:'model.reservation.location',value: query.get('location_name')})
                    this.stepNext();
                } else {
                    console.log('Invalid location_name:', locationName);
                } 
            }
        } 
    }
}
</script>

<style scoped>
    .m-cus-10{
        margin: 10px !important;;
    }
    .mb-cus-10{
        margin-bottom: 40px !important;
    }
    .mob-h1-font{
        font-size: 1.5rem;
    }
    .mob-h5-font{
        font-size: 1rem;
    }

    /*Large devices (desktops, 992px and up)*/
    @media (min-width: 992px) {
        .mob-h1-font{
            font-size: 2.25rem;
        }
        .mob-h5-font{
            font-size: 1.125rem;
        }
        .m-cus-10{
            margin: 40px !important;;
        }
        .mb-cus-10{
            margin-bottom: 50px !important;
        }
    }

    /*X-Large devices (large desktops, 1200px and up)*/
    @media (min-width: 1200px) {
        .m-cus-10{
            margin: 60px !important;
        }
        .mb-cus-10{
            margin-bottom: 60px !important;
        }
    }

</style>
